import ButtonComponent from '@BUP/components/Generics/Button'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useContext } from 'react'
import { LocationContext } from '@BUP/contexts/LocationContext'
import styles from './survey-element.module.scss'
import ResourceButton from './resource-button'
import { useGetPreAnalyticData } from '@BUP/hooks/Sociogram/preAnalyticData/useGetPreAnalyticData'
import { findNivel } from '@BUP/services/BraveUp'

const SurveyElement = ({ result, isMultiCourse }) => {
  const { survey } = result
  const { id: surveyId } = survey
  const i18n = useTranslation()
  const history = useHistory()
  const locale = useContext(LocationContext)
  const lang = locale && locale.locale

  const {
    isLoadingPreAnalyticData,
    preAnalyticData,
    errorPreAnalyticData
  } = useGetPreAnalyticData(surveyId)

  const { courses } = survey
  const course = Array.isArray(courses) && courses.length > 0 ? courses[0] : null
  const nivel = course ? findNivel(lang, course) : null
  const splitNivel = nivel && nivel.id.split(':')[1]
  const surveyName = isMultiCourse
    ? (splitNivel ? i18n.t(`common.resources.course.values.tags.nivel.${splitNivel}`) : survey.name)
    : (course?.name || survey.name)

  const courseName = isMultiCourse
    ? surveyName
    : (course?.name || surveyName)

  const organizationLanguage = locale && locale.lenguage

  const date = new Date(result.created_at).toLocaleString(
    organizationLanguage === 'ES' ? 'es-ES' : 'en-EN',
    {
      month: 'long',
      day: 'numeric'
    }
  )

  const handleClickSelectResult = () => {
    history.push({
      pathname: `/sociogram/historic-sociogram/dashboard/${surveyId}`,
      result,
      courseName,
      survey,
      preAnalyticData
    })
  }

  return (
    <div
      className={styles.container}
    >
      <div className={styles.text_wrapper}>
        <h4 className={styles.text}>
          {courseName}
        </h4>
        <span>{date}</span>
      </div>
      <div className={styles.buttons_wrapper}>
        <div className={styles.result_button_wrapper}>
          <ButtonComponent
            colorType='secondary'
            buttonText={i18n.t('pages.data.historicalSociogram.results.button.text')}
            size='small'
            onClick={() => handleClickSelectResult()}
            loading={isLoadingPreAnalyticData}
            disabled={errorPreAnalyticData}
          />
        </div>
        {!isMultiCourse
          ? (
            <ResourceButton result={result} courseName={courseName} />
            )
          : null}
      </div>
    </div>
  )
}

export default SurveyElement
